var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-progress-circular',{staticClass:"mx-3",attrs:{"indeterminate":"","color":"primary"}})}
var staticRenderFns = []

export { render, staticRenderFns }